import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';
import { pixelPageView } from '@/lib/pixel';
import { logToB3d } from '@/lib/b3dLogger';

export function Analytics() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
    pixelPageView();
    logToB3d(location.pathname + location.search);
  }, [location]);

  return null;
}
